<template>
  <div class="jiaru" style="padding-top: 50px;">
    <img class="banner" src="../../static/jiaru/banner1.png" alt />
    <div class="main">
      <p class="me">加入我们</p>
    </div>
    <div class="main-cent">
      <Row>
        <Col span="6" offset="4">
          <div class="jiaru">
            <img src="../../static/jiaru/logo1.png" alt />
            <p class="name">理想人才</p>
            <p class="text">
              员工是我们最宝贵的资产，也是简云科技持
              续取得成功的动力源泉。我们希望你拥有全
              局思维，拥抱大梦想，正直诚信，并且热衷
              于帮助企业创造互联网价值。
            </p>
          </div>
        </Col>
        <Col span="6">
          <div class="jiaru">
            <img src="../../static/jiaru/logo2.png" alt />
            <p class="name">职业发展</p>
            <p class="text">
              我们既是创新者，也是领导者，团队成员之
              间相互支持，开展良性竞争，并彼此鼓励。
              我们将成为你最强大的后盾，为你提供所需
              的工具。
            </p>
          </div>
        </Col>
        <Col span="6">
          <div class="jiaru">
            <img src="../../static/jiaru/logo3.png" alt />
            <p class="name">员工待遇</p>
            <p class="text">
              我们将为你提供业内极具竞争力的薪酬待遇，
              让你在产生价值的同时收获价值，并为你提
              供舒适、愉悦、利于创造价值的环境。
            </p>
          </div>
        </Col>
      </Row>
    </div>
    <div class="talent">
      <h2 class="talent_title">人才观</h2>
      <div class="talent_content">
        <div class="talent_contentLeft">
          <img src="../../static/image/rcg_left.png" alt />
        </div>
        <div class="talent_contentRight">
          <img src="../../static/image/rcg_right.png" alt />
        </div>
      </div>
    </div>
    <div class="Position_information">
      <h2 class="Position_title">职位信息</h2>
      <ul>
        <li v-for="(item,i) in recruitment_list" :key="i">
          <h3 class="position">{{item.job_name}}</h3>
          <div class="yaoqiu">{{item.education}}</div>
          <div class="fuli" >
            <div v-for="(key,i) in item.benefits" :key="i">
                <div class="jutifuli">{{key}}</div>
            </div>
          </div>
          <p class="responsibility">岗位职责</p>
          <p class="content" v-html="item.duties">
          </p>
          <p class="responsibility">岗位要求</p>
          <p class="content" v-html="item.demand">
            
          </p>
          <p class="workadd">{{item.address}}</p>
          <p class="address">
            简历投递地址：
            <a href="mailto:hr@jianyunkeji.net">hr@jianyunkeji.net</a>
          </p>
        </li>
      </ul>
    </div>
    <div class="Recruitment_information">
      <h2 class="Position_title">第三方招聘信息</h2>
      <div class="software" >
        <div class="software_left" v-for="(item,i) in jobLink_list" :key="i"  @click="goOtherPage(item)">
          <img :src="item.job_link_pic" alt />
          <i>{{item.job_link_name}}</i>
        </div>
      </div>
    </div>
    <div class="nb">
      <Row>
        <Col span="8" offset="12">
          <div style="margin-top:180px">
            <p>
              简云科技有一批专业的开发团队，我们是8090后，我们敢闯、我们敢拼。 永不放弃是我们的口号，
              永不言败是我们的座右铭。
            </p>
            <p>我们是一群平凡的人，凝聚在一起做不平凡的事。</p>
            <p>梦想：我们也有梦想，我们渴望有一天我们成为业内佼佼者；</p>
            <p>追求：我们追求完美，希望通过我们的努力为客户提供最完美的产品；</p>
            <p>执着：我们很执着，我们很直溜，我们为达目的誓不罢休。</p>
            <p>如果你有热情与兴趣加入简云团队，你就也可以成为这样的一群人之一。</p>
            <p>请将简历发送到 hr@jianyunkeji.net，我们将与你取得联系！</p>
          </div>
        </Col>
      </Row>
    </div>
    <!-- <div class="banner3">
      <Row class="code-row-bg">
        <Col class="jietext" span="10">
          我们营造了一个鼓励自由表达、坦诚沟通、个性化和多元化
          的环境，你将在这里不断成长。加入简云科技后，你将与其
          他富有创造力且拥有多年行业经验的员工一起团结协作，共
          同实现我们的愿景：共创联结商业时代。
        </Col>
      </Row>
    </div>-->
    <xfck></xfck>
  </div>
</template>

<script>
import xfck from "./xfck.vue";
export default {
  name: "jiaru",
  data() {
    return {
      msg: "加入我们",
      recruitment_list:[],
      jobLink_list:[
        {"job_link_name":"智联招聘","job_link_picg":"../../static/image/lagou.png","job_link_url":"https://fanyi.baidu.com/?aldtype=16047#zh/en/"},
        {"job_link_name":"拉钩招聘","job_link_picg":"../../static/image/lagou.png","job_link_url":"https://www.baidu.com/"},
      ]
    };
  },
  created(){
    this.get_recruitment()
    this.getJobLinkList()
  },
  methods: {
    get_recruitment() {
      var that = this;
      var url = that.baseUrl + "/jianyun/api/mall.php?c=job/getJobsList";
      that.axios
        .get(url, {
          params: {
            
          }
        })
        .then(res => {
          if (res.data.success) {
            that.recruitment_list = res.data.data.list
            //以中文，分隔
            for(var i = 0 ; i < that.recruitment_list.length; i++){
              that.recruitment_list[i].benefits=that.recruitment_list[i].benefits.split('，')
            }

          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    getJobLinkList() {
      var that = this;
      var url = that.baseUrl + "/jianyun/api/mall.php?c=job/getJobLinkList";
      that.axios
        .get(url, {
          params: {
            
          }
        })
        .then(res => {
          if (res.data.success) {
            res.data.data.list.forEach((item,index)=>{
              res.data.data.list[index].job_link_pic = that.img_url + item.job_link_pic
            })
            console.log(res.data.data.list)
            that.jobLink_list = res.data.data.list
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    goOtherPage(options){
    options.job_link_url = options.job_link_url.indexOf("http") ==-1?'http://'+options.job_link_url:options.job_link_url
      window.open(options.job_link_url)
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.yaoqiu{
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:300;
  color:rgba(153,153,153,1);
  margin: 12px 0 20px;
}
.fuli{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.jutifuli{
  width: 90px;
  height: 25px;
  line-height: 25px;
  text-align: center;
  background:rgba(255,255,255,1);
  border:1px solid rgba(253,123,53,1);
  border-radius:13px;
  margin-right: 5px;
  margin-bottom: 10px;
}
.workadd{
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:300;
  color:rgba(153,153,153,1);
  margin-left: 10px;
}
.code-row-bg {
  width: 1200px;
  height: 450px;
  margin: 0 auto;
  background: url(../../static/ing1/nb2.png) no-repeat;
  background-size: cover;
}

.jietext {
  margin-top: 190px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}
.nb {
  position: relative;
  background: url(../../static/ing1/shou.png) no-repeat;
  background-size: cover;
  width: 100%;
  height: 700px;
}
p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  margin-top: 30px;
}
.mx {
  position: absolute;
  right: 20%;
  top: 90px;
  width: 480px;
  height: 335px;
}
.meng {
  margin-top: 5%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
}
.name {
  margin-top: 5%;
  font-size: 20px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
}
.text {
  margin-top: 5%;
  width: 70%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
  margin-bottom: 15%;
}
.banner {
  width: 100%;
  height: 100%;
}
.main {
  margin-top: 3%;
  width: 100%;
}
.me {
  font-size: 36px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.main-cent {
  margin-top: 6%;
}
.banner2 {
  width: 100%;
  height: 100%;
}
.banner3 {
  position: relative;
  margin-top: 10%;
  margin-bottom: 10%;
}
.jiarutext {
  position: absolute;
  top: 50px;
  left: 10%;
  width: 300px;
  height: 200px;
  font-size: 18px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
  line-height: 28px;
}
.talent {
  width: 100%;
  height: 450px;
  background: url("../../static/image/talent.png") no-repeat;
  background-size: cover;
  margin: 20px 0;
}
.talent_title {
  text-align: center;
  color: #333333;
  font-size: 36px;
  font-weight: 300;
  font-family: MicrosoftYaHeiLight;
}
.Position_title {
  color: #333333;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  text-align: center;
}
.Position_information {
  padding: 20px 0;
}
.Position_information ul {
  list-style: none;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.Position_information ul li {
  width: 520px;
  padding: 10px;
  border: 1px solid #cccccc;
  margin: 10px 0;
  box-sizing: border-box;
  min-height: 580px;
  position: relative;
}
.Position_information ul li:hover {
  box-shadow: 0px 0px 10px rgba(204, 204, 204, 1);
}
.position {
  color: #333333;
  font-size: 18px;
  font-weight: 400;
  font-family: MicrosoftYaHei;
}
.responsibility {
  color: #333333;
  font-size: 16px;
  font-weight: 300;
  position: relative;
  margin: 5px 0;
  padding: 0 10px;
  margin: 30px 0 0 0;
}
.responsibility::before {
  content: "";
  width: 6px;
  height: 20px;
  background: rgba(253, 123, 53, 1);
  position: absolute;
  left: 0;
  top: 2px;
}
.content {
  color: #999;
  font-size: 14px;
  font-weight: 300;
  font-family: Microsoft YaHei;
  margin: 0;
  padding: 0 10px;
  line-height: 35px;
}
.address {
  position: relative;
  left: 10px;
  bottom: 20px;
  color: #fd7b35;
  font-size: 14px;
}
.address a {
  color: #fd7b35;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  text-decoration: none;
}
.talent_content {
  width: 1200px;
  margin: 0 auto;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
}
.talent_content > div {
  margin-top: 53px;
}
.Recruitment_information {
  padding: 20px 0;
}
.software {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
}
.software > div {
  margin: 30px 0;
}
.software_left {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
i {
  font-style: normal;
  color: #333333;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.software_right {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/jiaru.vue